import __request__ from "routing/request";
export function test(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.security/team-sync/test/backend", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
